module.exports = __webpack_public_path__ + "91e64aea42db10a63746e155a54d99d9.svg";